// extracted by mini-css-extract-plugin
module.exports = {"small":"Small_small__8xqpN","secondary":"Small_secondary__pYUEH","error":"Small_error__5iknu"};